import EncryptedStorageImage from "public/iaas/kubernetes.png";

export const IMPLEMENTATION_CONSTANTS = {
  image: EncryptedStorageImage,
  title: "Implementing Encrypted Storage Clusters",
  desc: "To deploy an Encrypted Storage Cluster, consider the following steps:",
  steps: [
    {
      label: "Select Appropriate Software or Platform",
      text: "Choose a storage solution that supports encryption and meets your organization's requirements.",
    },
    {
      label: "Set Up Infrastructure",
      text: "Prepare the necessary hardware or virtual machines to host the storage nodes.",
    },
    {
      label: "Configure Networking",
      text: "Ensure secure and reliable network connections between nodes, implementing measures like VPNs or private networks.",
    },
    {
      label: "Enable Encryption",
      text: "Configure encryption settings to ensure data is encrypted at rest and in transit.",
    },
    {
      label: "Implement Access Controls",
      text: "Set up authentication and authorization protocols to restrict data access to authorized users only.",
    },
    {
      label: "Regular Monitoring and Maintenance",
      text: "Continuously monitor the cluster for performance and security, applying updates and patches as necessary.",
    },
  ],
};
